import React, { useContext } from "react";
import CodeTag from "projects/components/CodeTag";
import CodeMultiSelect from "projects/components/CodeSelector/CodeMultiSelect";
import ProjectContext from "contexts/ProjectContext";

const ParagraphCodeList = ({
    codes,
    hasEditPermission,
    onCodeRemove,
    tagEnter,
    tagLeave,
    filteredExcerpts = [],
    showCodeSelector = false,
    selectedExcerptId = null,
    hasTextSelection = false
}) => {
    const projectContext = useContext(ProjectContext);
    const projectID = projectContext?.project?.id;

    const labels = [...codes.map((code, index) =>
        <CodeTag
          key={index}
          id={(code||{}).id}
          name={(code||{}).name}
          selected={(code||{}).selected}
          tagEnter={tagEnter}
          tagLeave={tagLeave}
          onCodeRemove={onCodeRemove}
          hasEditPermission={hasEditPermission}
          coders={code.coders}
          />
      )].filter((label) => label !== null);

    // Show CodeMultiSelect when there's an active selection (existing excerpt or new text)
    const showSelector = showCodeSelector && hasEditPermission && (selectedExcerptId || hasTextSelection);

    // Find the selected excerpt to get its current codes
    const selectedExcerpt = selectedExcerptId
        ? filteredExcerpts.find(e => e.id?.toString() === selectedExcerptId?.toString())
        : null;
    const excerptCodeIds = selectedExcerpt
        ? (selectedExcerpt.codings || []).map(c => c.code_id)
        : [];

    const codeSelector = showSelector ? (
        <CodeMultiSelect
            projectID={projectID}
            excerptCodeIds={excerptCodeIds}
            excerptId={selectedExcerpt?.id}
            placement="bottom-start"
        />
    ) : null;

    return (
        <div className="codelist" style={{
            width: "100%",
            wordWrap: 'break-word',
            // On the comparison page, set consistent line height and min height to prevent
            // layout shift when the "+" button appears/disappears on excerpt selection
            ...(showCodeSelector ? { lineHeight: '27px', minHeight: '27px' } : {})
        }}>
            {codeSelector}
            {labels}
        </div>
    )
};

export default ParagraphCodeList;
